/* eslint-disable */
import { call, put, takeLatest, select } from "redux-saga/effects";
import { types } from "reducers/adheredServices";
import {
    adheredServicesList,
    adheredServicesDetail,
    adheredServicesRename,
    adheredServicesUnbind,
} from "middleware/adheredServices";
import { actions as notificationActions } from "reducers/notification";
import * as i18n from "util/i18n";
import { routerActions, push } from "connected-react-router";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as adServiceSelectors } from "reducers/adheredServices";

const sagas = [
    takeLatest(types.AD_SERVICE_LIST_REQUEST, serviceList),
    takeLatest(types.AD_SERVICE_DETAIL_REQUEST, serviceDetail),
    takeLatest(types.AD_SERVICE_RENAME_REQUEST, serviceRename),
    takeLatest(types.AD_SERVICE_REMOVE_REQUEST, serviceRemove),
];

export default sagas;

function* serviceList() {
    try {
        const response = yield call(adheredServicesList);
        if (response.type === "W") {
            yield put({ type: types.AD_SERVICE_LIST_FAILURE });
        } else {
            yield put({
                type: types.AD_SERVICE_LIST_SUCCESS,
                adheredServicesList: response.data.data,
            });
        }
    } catch (error) {
        yield put({ type: types.AD_SERVICE_LIST_FAILURE });
    }
}
function* serviceDetail({ serviceId }) {
    const activeEnvironment = yield select(sessionSelectors.getActiveEnvironment);
    const userCode = activeEnvironment?.id;
    const response = yield call(adheredServicesDetail, userCode, serviceId);
    if (response.type === "W") {
        yield put({ type: types.AD_SERVICE_DETAIL_FAILURE });
    } else {
        yield put({
            type: types.AD_SERVICE_DETAIL_SUCCESS,
            adheredServicesDetail: response.data.data.rapipagoService,
        });
    }
}

function* serviceRename({ serviceId, value }) {
    const adheredServicesList = yield select(adServiceSelectors.getList);

    try {
        const response = yield call(adheredServicesRename, { serviceId, value });
        if (response.type === "W") {
            yield put({ type: types.AD_SERVICE_RENAME_FAILURE });
            yield put(notificationActions.showNotification(response.data.message, "error", ["adheredServices.list"]));
        } else {
            const renamedService = response.data.data.rapipagoService;
            const renamedList = adheredServicesList.map((item) =>
                item.serviceId === renamedService.serviceId ? { ...item, alias: renamedService.alias } : item,
            );

            yield put({
                type: types.AD_SERVICE_RENAME_SUCCESS,
                adheredServicesRename: renamedList,
            });
            yield put(
                notificationActions.showNotification(i18n.get("adheredService.succes.label"), "success", [
                    "adheredServices.list",
                ]),
            );
        }
    } catch (error) {
        yield put({ type: types.AD_SERVICE_RENAME_FAILURE });
        yield put(notificationActions.showNotification(response.data.message, "error", ["adheredServices.list"]));
    }
}
function* serviceRemove({ serviceId }) {
    const activeEnvironment = yield select(sessionSelectors.getActiveEnvironment);
    const userCode = activeEnvironment?.id;
    const response = yield call(adheredServicesUnbind, { userCode, serviceId });
    if (response.type === "W") {
        yield put({ type: types.AD_SERVICE_REMOVE_FAILURE });
        yield put(routerActions.push("/adheredServices/list"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["adheredServices.list"]));
    } else {
        yield put({
            type: types.AD_SERVICE_REMOVE_SUCCESS,
            adheredServicesRemove: response.data.data,
        });
        yield put(routerActions.push("/adheredServices/list"));
        yield put(
            notificationActions.showNotification(i18n.get("adheredService.unbind.succes.label"), "success", [
                "adheredServices.list",
            ]),
        );
    }
}
